// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3bHLH","list":"BalanceDue_list__2k5zS","listRow":"BalanceDue_listRow__20UVE","total":"BalanceDue_total__142tK"};